import { DEFAULT_MEASURES } from './config';
import { formatCallDuration, formatTimeSpan, ticksFormat } from './datetime';

export class Measure {
  static bytesToHuman(bytes, si) {
    if (!bytes) bytes = 0;
    let thresh = si ? 1000 : 1024;
    if (bytes < thresh) return bytes + ' B';
    let units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : [
      'KiB',
      'MiB',
      'GiB',
      'TiB',
      'PiB',
      'EiB',
      'ZiB',
      'YiB',
    ];
    let u = -1;
    do {
      bytes /= thresh;
      ++u;
    } while (bytes >= thresh);
    return bytes.toFixed(1) + ' ' + units[u];
  }

  static getMeasure(cell, name) {
    let val = typeof(cell) === 'object' ? cell && cell[name] || 0 : cell;
    if (name === 'activity_time_sum') {
      return ticksFormat(val);
    } else if (name === 'call_duration_sum') {
      return formatCallDuration(val);
    } else {
      return val;
    } //bytesToHuman(val, true );
  }

  static getMeasureLabel(name) {
    return DEFAULT_MEASURES[name];
  }

  static getMeasures() {
    return Object.keys(DEFAULT_MEASURES);
  }
}



// WEBPACK FOOTER //
// ./src/common/measure.js